import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HandbookSection = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 3C1.72386 3 1.5 3.22386 1.5 3.5C1.5 3.77614 1.72386 4 2 4H11C11.2761 4 11.5 3.77614 11.5 3.5C11.5 3.22386 11.2761 3 11 3H2ZM2 9C1.72386 9 1.5 9.22386 1.5 9.5C1.5 9.77614 1.72386 10 2 10H11C11.2761 10 11.5 9.77614 11.5 9.5C11.5 9.22386 11.2761 9 11 9H2ZM1.5 6.5C1.5 6.22386 1.72386 6 2 6H3C3.27614 6 3.5 6.22386 3.5 6.5C3.5 6.77614 3.27614 7 3 7H2C1.72386 7 1.5 6.77614 1.5 6.5ZM2 12C1.72386 12 1.5 12.2239 1.5 12.5C1.5 12.7761 1.72386 13 2 13H3C3.27614 13 3.5 12.7761 3.5 12.5C3.5 12.2239 3.27614 12 3 12H2ZM4.5 6.5C4.5 6.22386 4.72386 6 5 6H14C14.2761 6 14.5 6.22386 14.5 6.5C14.5 6.77614 14.2761 7 14 7H5C4.72386 7 4.5 6.77614 4.5 6.5ZM5 12C4.72386 12 4.5 12.2239 4.5 12.5C4.5 12.7761 4.72386 13 5 13H14C14.2761 13 14.5 12.7761 14.5 12.5C14.5 12.2239 14.2761 12 14 12H5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default HandbookSection
